import { Injectable } from '@angular/core';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { TouchAndMouseHandlerService } from '../touch-and-mouse-handler.service';
import { UserOperation } from '../../enums/user-operation';
import { Subject } from 'rxjs';
import { ShiveDialogSettings } from '../../../shared/data-types/dialog-types';

@Injectable({
  providedIn: 'root',
})
export class ShiveDialogService {
  public onOutsideClickSub = new Subject();
  private readonly dialogRef: DialogRef[] = [];
  private closeOnOutsideClick: boolean;

  constructor(
    private readonly dialogService: DialogService,
    private readonly touchAndMouseHandlerService: TouchAndMouseHandlerService,
  ) {
    this.touchAndMouseHandlerService.globalMouseReleased$.subscribe((e) => {
      const haystack = Array.from((e.target as HTMLElement).classList);
      const outsideClasses = ['k-overlay', 'tb'];
      // User clicked outside of dialog
      if (
        this.dialogRef.length > 0 &&
        this.closeOnOutsideClick &&
        outsideClasses.some((val) => haystack.includes(val))
      ) {
        this.close(UserOperation.Cancel);
        this.onOutsideClickSub.next(null);
      }
    });
  }

  public open(options: ShiveDialogSettings, closeOnOutsideClick = true): DialogRef {
    if (!options.width) {
      options.width = 572;
    }

    if (!options.animation) {
      options.animation = false;
    }

    this.closeOnOutsideClick = closeOnOutsideClick;
    const ref = this.dialogService.open(options);

    // Optionally move the dialog in any direction by any value in px.
    setTimeout(() => {
      const wrapperEl = ref.dialog.instance.dialog.nativeElement;
      // Move in x - direction
      const currentX = parseInt(getComputedStyle(wrapperEl).left, options.offsetX) || 0;
      wrapperEl.style.left = `${currentX + options.offsetX}px`;

      // Move in x - direction
      const currentY = parseInt(getComputedStyle(wrapperEl).left, options.offsetY) || 0;
      wrapperEl.style.left = `${currentY + options.offsetY}px`; // Move 10px to the right
    });

    this.dialogRef.push(ref);
    return ref;
  }

  public close(result?: unknown): void {
    if (this.dialogRef.length === 0) {
      throw new Error('No dialog ref available.');
    }

    this.dialogRef.pop().close(result);
  }
}
